export const COUNT_LIST_REQUEST ='COUNT_LIST_REQUEST'
export const COUNT_LIST_SUCCESS ='COUNT_LIST_SUCCESS'
export const COUNT_LIST_FAIL ='COUNT_LIST_FAIL'

export const GET_BOOKING_LIST_REQUEST ='GET_BOOKING_LIST_REQUEST'
export const GET_BOOKING_LIST_SUCCESS ='GET_BOOKING_LIST_SUCCESS'
export const GET_BOOKING_LIST_FAIL ='GET_BOOKING_LIST_FAIL'

export const APPROVE_BOOKING_REQUEST ='APPROVE_BOOKING_REQUEST'
export const APPROVE_BOOKING_SUCCESS ='APPROVE_BOOKING_SUCCESS'
export const APPROVE_BOOKING_FAIL ='APPROVE_BOOKING_FAIL'
export const APPROVE_BOOKING_RESET ='APPROVE_BOOKING_RESET'

export const REJECT_BOOKING_REQUEST ='REJECT_BOOKING_REQUEST'
export const REJECT_BOOKING_SUCCESS ='REJECT_BOOKING_SUCCESS'
export const REJECT_BOOKING_FAIL ='REJECT_BOOKING_FAIL'
export const REJECT_BOOKING_RESET ='REJECT_BOOKING_RESET'


export const GET_SIGNUP_REQUEST ='GET_SIGNUP_REQUEST'
export const GET_SIGNUP_SUCCESS ='GET_SIGNUP_SUCCESS'
export const GET_SIGNUP_FAIL ='GET_SIGNUP_FAIL'

export const APPROVE_USER_REQUEST ='APPROVE_USER_REQUEST'
export const APPROVE_USER_SUCCESS ='APPROVE_USER_SUCCESS'
export const APPROVE_USER_FAIL ='APPROVE_USER_FAIL'
export const APPROVE_USER_RESET ='APPROVE_USER_RESET'

export const REJECT_USER_REQUEST ='REJECT_USER_REQUEST'
export const REJECT_USER_SUCCESS ='REJECT_USER_SUCCESS'
export const REJECT_USER_FAIL ='REJECT_USER_FAIL'
export const REJECT_USER_RESET ='REJECT_USER_RESET'

export const CREATE_PASSWORD_REQUEST ='CREATE_PASSWORD_REQUEST'
export const CREATE_PASSWORD_SUCCESS ='CREATE_PASSWORD_SUCCESS'
export const CREATE_PASSWORD_FAIL ='CREATE_PASSWORD_FAIL'
export const CREATE_PASSWORD_RESET ='CREATE_PASSWORD_RESET'


export const GET_ALL_APPROVED_USER_REQUEST ='GET_ALL_APPROVED_USER_REQUEST'
export const GET_ALL_APPROVED_USER_SUCCESS ='GET_ALL_APPROVE_USER_SUCCESS'
export const GET_ALL_APPROVED_USER_FAIL ='GET_ALL_APPROVED_USER_FAIL'
export const GET_ALL_APPROVED_USER_RESET ='GET_ALL_APPROVED_USER_RESET'


export const SUSPEND_USER_REQUEST ='SUSPEND_USER_REQUEST'
export const SUSPEND_USER_SUCCESS ='SUSPEND_USER_SUCCESS'
export const SUSPEND_USER_FAIL ='SUSPEND_USER_FAIL'
export const SUSPEND_USER_RESET ='SUSPEND_USER_RESET'


export const ADMIN_SIGNIN_REQUEST = 'ADMIN_SIGNIN_REQUEST';
export const ADMIN_SIGNIN_SUCCESS = 'ADMIN_SIGNIN_SUCCESS';
export const ADMIN_SIGNIN_FAIL = 'ADMIN_SIGNIN_FAIL';

export const ADMIN_SIGNOUT = 'ADMIN_SIGNOUT';



export const UN_SUSPEND_USER_REQUEST ='UN_SUSPEND_USER_REQUEST'
export const UN_SUSPEND_USER_SUCCESS ='UN_SUSPEND_USER_SUCCESS'
export const UN_SUSPEND_USER_FAIL ='UN_SUSPEND_USER_FAIL'
export const UN_SUSPEND_USER_RESET ='UN_SUSPEND_USER_RESET'